import { render, staticRenderFns } from "./CorporationRoleCreate.vue?vue&type=template&id=36426ac8&scoped=true"
import script from "./CorporationRoleCreate.vue?vue&type=script&lang=js"
export * from "./CorporationRoleCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36426ac8",
  null
  
)

export default component.exports